var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{staticClass:"featured-services"},[_c('h2',[_vm._v("Popular services")]),_c('PostPreviewList',{attrs:{"posts":_vm.services,"postRouteName":"services.service","buttonText":"More"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }